import React from 'react';
import { Link } from 'react-router-dom';
import { MyLocation, Group, MenuBook } from '@mui/icons-material';

const CallToAction = () => {

  return (
    <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-bold mb-6">Ready to Join Our Community?</h2>
            <p className="text-lg mb-8 opacity-90">Experience the difference that quality education makes. Schedule a campus visit and discover how Moxie Master Public School can shape your child's future.</p>
            <div className="flex flex-col gap-4 mb-8">
              <div className="flex items-center gap-4">
                <div className="text-2xl"><MyLocation style={{ fontSize: '1.5rem', color: '#4A90E2' }} /></div>
                <span className="text-lg font-medium">Personalized Campus Tour</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="text-2xl"><Group style={{ fontSize: '1.5rem', color: '#4A90E2' }} /></div>
                <span className="text-lg font-medium">Meet Our Teachers</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="text-2xl"><MenuBook style={{ fontSize: '1.5rem', color: '#4A90E2' }} /></div>
                <span className="text-lg font-medium">See Our Facilities</span>
              </div>
            </div>
            <div className="flex gap-4 flex-wrap">
              <Link to="/contact" className="inline-block px-8 py-3 rounded-lg font-medium text-white bg-yellow-400 hover:bg-yellow-500 transition-all text-lg shadow-lg">Schedule a Visit</Link>
              <Link to="/admissions" className="inline-block px-8 py-3 rounded-lg font-medium text-blue-800 border-2 border-white bg-white hover:bg-blue-800 hover:text-white transition-all text-lg shadow-lg">Learn More</Link>
            </div>
          </div>
          <div className="flex justify-center items-center">
            <div className="w-full h-96 bg-white/10 rounded-xl flex items-center justify-center text-white text-xl font-medium shadow-lg border border-white/20 backdrop-blur overflow-hidden">
              <iframe
                title="Campus Location Map"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps?q=18.483594,73.811095&z=16&output=embed"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction; 